import { useEffect, useState } from "react";
import { api } from "@/lib/soul";
import { useAuth } from "@/context/AuthContext";

// A soft glowing light on the home screen that reflects the feeling of recent entries.
export default function MoodPulse() {
  const { user } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!user) {
      setData(null);
      return;
    }
    api.get("/journal/mood-pulse").then((r) => setData(r.data.result)).catch(() => {});
  }, [user]);

  if (!user || !data) return null;

  const color = data.color || "#D4AF37";
  const intensity = typeof data.intensity === "number" ? data.intensity : 0.4;
  const glow = 0.25 + intensity * 0.55; // visible floor

  return (
    <section data-testid="mood-pulse" className="max-w-7xl mx-auto px-6 pt-8">
      <div className="glass rounded-3xl px-6 py-8 flex items-center gap-8">
        <div className="relative h-28 w-28 shrink-0 grid place-items-center">
          <span
            className="absolute rounded-full slow-pulse"
            aria-hidden
            data-testid="mood-pulse-orb"
            style={{
              height: "7rem",
              width: "7rem",
              background: `radial-gradient(circle, ${color} 0%, ${color}88 35%, transparent 72%)`,
              opacity: glow,
              filter: "blur(2px)",
              boxShadow: `0 0 70px ${color}`,
            }}
          />
          <span
            className="absolute rounded-full border"
            aria-hidden
            style={{ height: "4.5rem", width: "4.5rem", borderColor: `${color}66` }}
          />
        </div>
        <div className="min-w-0">
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#B4A897] mb-1">Your inner weather</p>
          <p data-testid="mood-pulse-word" className="serif text-3xl sm:text-4xl capitalize" style={{ color }}>
            {data.mood}
          </p>
          <p data-testid="mood-pulse-note" className="mt-2 text-[#B4A897] italic-serif text-lg leading-relaxed">
            {data.note}
          </p>
        </div>
      </div>
    </section>
  );
}
